import {TOption} from './TOption'

export const FINANCIAL_DOC_TYPE: TOption[] = [
  {value: 'skbdn', label: 'SKBDN'},
  {value: 'bg', label: 'Bank Guarantee'},
  {value: 'lc', label: 'Letter of Credit'},
]
